import React, { useState, useEffect } from "react";
import { Menu, MenuItem, Sidebar, useProSidebar} from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { RxDashboard, RxPencil2 } from "react-icons/rx";
import { VscBell, VscGear } from 'react-icons/vsc';
import { FaRegChartBar } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import { SlClock } from "react-icons/sl";
import { COMPLIANCE_APPROVED } from "../utilities";
import Cookies from 'js-cookie';




const InvestorSideNavBar = () => {

    const { collapseSidebar,  collapsed } = useProSidebar(false);

const [activeItem, setActiveItem] = useState()
// const menuItems = [{"Menu":"Dashboard","URL":"/investordashboard","icon":<RxDashboard />,"active":false},{"Menu":"My Investments","URL":"/myinvestments","icon":<FaRegChartBar/>,"active":false}, {"Menu":"Investment Opportunities","URL":"/investmentopportunities","icon":<RxPencil2 />,"active":false},{"Menu":"KYC Documents","URL":"/investorkycdocuments","icon":<FiFileText/>,"active":false},{"Menu":"History","URL":"/investorhistory","icon":<SlClock/>,"active":false},{"Menu":"Notifications","URL":"/investornotifications","icon":<VscBell />,"active":false},{"Menu":"KYC Form","URL":"/investorsettings","icon":<VscGear />,"active":false}]

// const menuItems = [{"Menu":"Dashboard","URL":"/investordashboard","icon":<RxDashboard />,"active":false},{"Menu":"My Investments","URL":"/myinvestments","icon":<FaRegChartBar/>,"active":false}, {"Menu":"Investment Opportunities","URL":"/investmentopportunities","icon":<RxPencil2 />,"active":false},{"Menu":"KYC Documents","URL":"/investorkycdocuments","icon":<FiFileText/>,"active":false},{"Menu":"History","URL":"/investorhistory","icon":<SlClock/>,"active":false},{"Menu":"Notifications","URL":"/investornotifications","icon":<VscBell />,"active":false},{"Menu":"KYC Form","URL":"/investorKyc","icon":<VscGear />,"active":false}]
  const menuItems = [
    { "Menu": "Dashboard", "URL": "/investordashboard", "icon": <RxDashboard />, "active": false },
    { "Menu": "My Investments", "URL": "/myinvestments", "icon": <FaRegChartBar />, "active": false },
    { "Menu": "Investment Opportunities", "URL": "/investmentopportunities", "icon": <RxPencil2 />, "active": false },
    { "Menu": "KYC Documents", "URL": "/investorkycdocuments", "icon": <FiFileText />, "active": false },
    { "Menu": "History", "URL": "/investorhistory", "icon": <SlClock />, "active": false },
    { "Menu": "Notifications", "URL": "/investornotifications", "icon": <VscBell />, "active": false },
    { "Menu": "Approvals", "URL": "/investorapprovals", "icon": <FiFileText />, "active": false },
    { "Menu": "KYC Form", "URL": "/investorKyc", "icon": <VscGear />, "active": false }
  ]

useEffect(() => {
    const currentUrl = window.location.pathname;
    const activeMenuItem = menuItems.find((item) => item.URL === currentUrl);
    if (activeMenuItem) {
      setActiveItem(activeMenuItem.Menu);
    }
  },[]);
  const handleMenuItemClick = (menu) => {
    if (menu === activeItem) {
      window.location.reload();
    } else {
      setActiveItem(menu);
    }
  };
    return (
        <div style={{ display: 'flex', height: '100vh', maxWidth:"250px"}} className='sidenavbar'>
            <Sidebar className='sidebarprohead ' >
                <span onClick={() => collapseSidebar()} >
                    {collapsed ? <img src="./images/bean_logo.svg" alt="true" className="sidebarimg" /> : <img src="./images/New_white_blue_brand_name.svg" alt="true" className="brand_logo_styl" />}
                    </span>
                
                <Menu>
                    {menuItems.map((eachitem, index) =>{
                        return(
                          <div>
                          {Cookies.get("kyc_status") != COMPLIANCE_APPROVED ? 
                            <Link className={`${eachitem.URL!=='/investorsettings'? "d-none":'' }`} key={index} to={eachitem.URL} ><MenuItem className={ `${activeItem === eachitem.Menu ? "sidebar_li_styl":""}`} icon={eachitem.icon} active={activeItem === eachitem.Menu} onClick={() => handleMenuItemClick(eachitem.Menu)}> {eachitem.Menu}</MenuItem></Link> 
                            :
                            <Link key={index} to={eachitem.URL} ><MenuItem className={ `${activeItem === eachitem.Menu ? "sidebar_li_styl":""}`} icon={eachitem.icon} active={activeItem === eachitem.Menu} onClick={() => handleMenuItemClick(eachitem.Menu)}> {eachitem.Menu}</MenuItem></Link> 
                            }
                            </div>
                        )

                    })}
                </Menu>
            </Sidebar>
        </div>
    )

}
export default InvestorSideNavBar;